<div class="text-center spinner"
     [style.height]="lineHeight">
  <div style="display: table; height: 100%; width: 100%;">
    <i class="fa fa-spinner fa-pulse fa-fw"
       [style.font-size]='size'
       [style.color]="color"></i>
    <span class="sr-only ">{{ 'loading' | translate }}</span>
    <span *ngIf="loadingText" style="display: table-row"
          [style.color]="color" [style.opacity]="'0.4'">{{ loadingText }}</span>
  </div>
</div>
